import { Swiper, Navigation, SwiperOptions, Autoplay } from 'swiper';
import { ImageGalleryModel } from '../empracoTypes';
import { ImageGalleryFullscreenWrapper } from './ImageGalleryFullscreen';
import { render } from '../main';
import ReactDOM from 'react-dom';

export default function ImageGallery(parent: HTMLDivElement | null, model: ImageGalleryModel) {
  if (!parent) {
    return;
  }

  const slides = model.imageGalleryEditorModel.slides;

  const options: SwiperOptions = {
    modules: [
      Navigation,
      Autoplay
    ],
    autoplay: model.autoplay ? { delay: model.delay } : false,
    lazy: true,
    loop: slides.length > 1,
    autoHeight: model.staticHeight === 0,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },
    spaceBetween: 0
  };

  const swiper = new Swiper(parent, options);

  if (model.fullscreenEnabled) {
    const fsSlides = slides.map(slide => slide.image);

    if (!fsSlides) {
      return;
    }

    const fsTrigger = parent.querySelector('.empori-image-gallery-fullscreen-trigger');

    if (!fsTrigger) {
      return;
    }

    const fsEl = document.createElement('div');
    fsEl.classList.add('empori-fullscreen-image-gallery');
    document.body.appendChild(fsEl);

    const removeInnerContent = (activeIndex: number) => {
      swiper.slideToLoop(activeIndex);
      fsEl.classList.remove('visible');
      ReactDOM.unmountComponentAtNode(fsEl);
    };

    fsTrigger.addEventListener('click', e => {
      fsEl.classList.add('visible');
      render(
        <ImageGalleryFullscreenWrapper
          slideImgUrls={fsSlides}
          onClose={removeInnerContent}
          activeIndex={swiper.realIndex}
        />, fsEl);
    });
  }
  return swiper;
}